import type { NotificationsRepositoryState } from "./types";
import { withState } from "../../Repository";

export const makeState = <TNotification extends object>() => withState<NotificationsRepositoryState<TNotification>>({
    data: null,
});
